import React, { useEffect } from "react";
import ModalImage from "react-modal-image";

export default function CustomModalImage({ file, index }) {
    const handleDownload = async (fileUrl) => {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileUrl.split("?")[0].split("/").pop() || "download.png";
        link.click();

        window.URL.revokeObjectURL(url);
    };

    useEffect(() => {
        const observer = new MutationObserver(() => {
            // Select the modal currently open
            const modals = document.querySelectorAll(".__react_modal_image__icon_menu");

            modals.forEach((header) => {
                if (!header.querySelector(`.custom-download-btn[data-file='${file}']`)) {
                    const btn = document.createElement("span");
                    btn.innerText = "⬇";
                    btn.className = "custom-download-btn";
                    btn.dataset.file = file;
                    btn.dataset.index = index;
                    btn.style.cursor = "pointer";
                    btn.style.fontSize = "25px";
                    btn.style.marginLeft = "12px";
                    btn.style.marginTop = "-12px";
                    btn.style.color = "white";
                    btn.style.position = "absolute";
                    btn.style.right = "95px";
                    btn.style.top = "16px";
                    btn.style.zIndex = "9999";

                    btn.onclick = () => handleDownload(file);

                    header.appendChild(btn);
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [file, index]);

    return (
        <div className="custom-modal-wrapper">
            <ModalImage
                small={file}
                large={file}
                alt={`Attached File ${index}`}
                hideDownload={true}
            />
        </div>
    );
}
